<!--
 * @Author:
 * @LastEditTime: 2024-06-19 17:43:49
 * @Description: 承包商人员档案管理
-->
<template>
  <div class="h-full">
    <el-row class="flex h-full" :gutter="10" v-if="currentComp === 'TABLE'">
      <el-col class="w-300px h-full">
        <el-card class="h-full">
          <div class="flex text-14px mb-10px">
            <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">外委单位</span>
          </div>
          <div class="flex mt-10px mb-10px">
            <el-input
              size="small"
              clearable
              placeholder="请输入"
              class="flex-1 mr-10px"
              v-model="treeKeyword"
            />
            <el-button size="small" type="primary" @click="$refs.tree.filter(treeKeyword)"
              >搜索</el-button
            >
          </div>
          <div class="tree overflow-y-auto">
            <el-tree
              v-loading="treeLoading"
              highlight-current
              :data="treeData"
              @node-click="handleDocNodeClick"
              :filter-node-method="filterTreeNode"
              :expand-on-click-node="false"
              :props="defaultTreeProps"
              node-key="id"
              ref="tree"
              :default-expanded-keys="defaultExpandIds"
              @node-expand="nodeExpand"
              @node-collapse="nodeCollapse"
            >
              <div slot-scope="{ node, data }" class="node-item">
                <div class="custom-tree-node">
                  <p :title="node.label" class="text-overflow truncate">
                    {{ node.label }}
                  </p>
                  <div>
                    <span class="text-red-500 ml-5px" v-if="data.status === 2">
                      {{ `[${unitStatusMap(data.status)}]` }}</span
                    >
                    <span class="text-red-500 ml-5px" v-if="data.isBlock"> [黑名单]</span>
                  </div>
                </div>
              </div>
            </el-tree>
          </div>
        </el-card>
      </el-col>
      <el-col class="h-full rightCol flex-1">
        <el-card class="h-full" :body-style="{ padding: '20px !important' }" v-loading="loading">
          <!-- <div class="text-base font-bold mb-20px" v-if="currentTreeSelect">
            {{ currentTreeSelect.orgName }}
          </div> -->
          <div class="flex items-center  mb-5px" v-if="currentTreeSelect">
            <span class="border-l-3 border-color-primary pl-10px text-18px">{{
              currentTreeSelect.orgName
            }}</span>
          </div>
          <div class="flex mb-10px mr-10px">
            <div>
              <el-input
                size="small"
                class="mr-10px !w-54 mb-10px"
                placeholder="姓名、联系电话"
                v-model="searchData.nameOrPhoneNumber"
                clearable
              ></el-input>
              <el-select
                v-model="searchData.status"
                size="small"
                class="mr-10px !w-50 mb-10px"
                placeholder="人员状态"
                clearable
              >
                <el-option
                  v-for="item in statusFilterList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
              <el-select
                v-model="searchData.isSpecialOperationCertificatePersonnel"
                size="small"
                class="mr-10px !w-50 mb-10px"
                placeholder="是否特种作业人员"
                clearable
              >
                <el-option
                  v-for="item in isSpecialOperationCertificatePersonnelList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="item.code"
                ></el-option>
              </el-select>
              <el-select
                v-model="searchData.isBlock"
                size="small"
                class="mr-10px !w-54 mb-10px"
                placeholder="请选择是否黑名单"
                clearable
              >
                <el-option
                  v-for="item in blackList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="item.code"
                ></el-option>
              </el-select>
              <el-select
                v-model="searchData.workflowStatus"
                size="mini"
                placeholder="流程状态"
                class="!w-50 mr-10px mb-10px"
                clearable
              >
                <el-option
                  v-for="item in workFlowStatusList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="item.code"
                ></el-option>
              </el-select>
              <el-button class="mb-10px mr-10px" size="small" type="primary" @click="handleSearch"
                >搜索</el-button
              >
              <el-button class="mb-10px" size="small" @click="resetSearch">重置</el-button>

              <el-button
                class="mb-10px"
                size="small"
                @click="handleAddBlack"
                :disabled="!$hasAccess('addBlack')"
                >加入黑名单</el-button
              >
              <el-button
                class="mb-10px"
                size="small"
                @click="handleRemove"
                :disabled="!$hasAccess('removeBlack')"
                >移除黑名单</el-button
              >
              <el-button
                size="small"
                class="mb-10px"
                @click="updateProject"
                :disabled="!$hasAccess('changeProject')"
                >变更项目</el-button
              >
            </div>
          </div>
          <el-table
            :data="tableData"
            height="calc(100% - 200px)"
            border
            stripe
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="50" :selectable="isDisabled"></el-table-column>
            <el-table-column label="姓名" prop="name" show-overflow-tooltip></el-table-column>
            <el-table-column
              label="所属项目"
              prop="projectNames"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              label="联系电话"
              prop="phoneNumber"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="年龄" prop="age"></el-table-column>
            <el-table-column
              label="是否特种作业人员"
              prop="isSpecialOperationCertificatePersonnel"
              width="200"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ !!scope.row.isSpecialOperationCertificatePersonnel ? '是' : '否' }}
              </template>
            </el-table-column>
            <el-table-column label="人员状态" prop="status">
              <template slot-scope="scope">
                <el-tag size="mini" :type="unitStatusTypes(scope.row.status)">{{
                  unitStatusMap(scope.row.status)
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column width="100" label="是否黑名单" prop="isBlock">
              <template slot-scope="scope">
                <el-tag size="mini" type="danger" v-if="scope.row.isBlock === true">是</el-tag>
                <el-tag size="mini" type="success" v-else-if="scope.row.isBlock === false"
                  >否</el-tag
                >
                <span v-else></span>
              </template>
            </el-table-column>
            <el-table-column label="流程状态" prop="workflowStatus">
              <template slot-scope="scope">
                <el-tag size="mini" :type="workFlowStatusTypes(scope.row.workflowStatus)">{{
                  workFlowStatusMap(scope.row.workflowStatus)
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  :disabled="!$hasAccess('read')"
                  size="mini"
                  @click="handleDetail(scope.row)"
                  >查看</el-button
                >
                <el-button
                  :disabled="!$hasAccess('readFlow')"
                  size="mini"
                  @click="handleFlow(scope.row)"
                  >查看流程</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            @size-change="tableSizeChange"
            @current-change="tableCurrentChange"
            :current-page.sync="pageConfig.SkipCount"
            :page-size.sync="pageConfig.MaxResultCount"
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[15, 30, 45, 60, 75, 90]"
            :total="total"
            class="float-right mt-20px ml-20px"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <!-- 详情 -->
    <el-card v-if="currentComp === 'DETAIL'" class="w-full h-full overflow-y-hidden">
      <div class="flex justify-between items-center">
        <div class="title text-lg mb-10px cursor-pointer">
          <el-page-header @back="handleBack" content="详情"></el-page-header>
        </div>
      </div>

      <el-tabs v-model="activeModule">
        <el-tab-pane
          v-for="item in moduleList"
          :key="item.module"
          :label="item.moduleName"
          :name="item.module"
        ></el-tab-pane>
      </el-tabs>
      <div class="w-full detail-height">
        <!-- 基本信息 -->
        <person-enter-content
          v-if="activeModule == '0'"
          :FormData="formData"
          :formList="formList"
          @back="handleBack"
          @save="handleBack"
          pageType="detail"
          currentPage="PersonFiles"
          :showCountInfo="true"
        ></person-enter-content>
        <train-manage-record-list v-if="activeModule == '1'" :userId="saveRowData.accountId">
        </train-manage-record-list>
        <exam-manage-record-study
          v-if="activeModule == '2'"
          :userId="saveRowData.accountId"
        ></exam-manage-record-study>
        <anti-violation-management-file-info
          v-if="activeModule == '3'"
          :userId="saveRowData.accountId"
          :unitId="saveRowData.orgId"
          @showviolationDialog="showviolationDialog"
        ></anti-violation-management-file-info>
      </div>
    </el-card>

    <!-- 加入黑名单 -->
    <el-dialog
      :close-on-click-modal="false"
      title="加入黑名单"
      :visible.sync="dialogBlackShow"
      width="560px"
      class="mini-dialog"
      v-dialogDrag
    >
      <el-form ref="formActive" label-width="180px" :model="FormData">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="评价等级" prop="evaluationlevel">
              <el-rate class="leading-loose" v-model="FormData.evaluationlevel" show-text>
              </el-rate>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="评价意见" prop="evaluationOpinions">
              <el-input
                v-model="FormData.evaluationOpinions"
                type="textarea"
                :rows="4"
                maxlength="500"
                show-word-limit
                placeholder="请填写评价意见"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
        <el-button size="small" @click="dialogBlackShow = false">取消</el-button>
      </div>
    </el-dialog>

    <!-- 变更项目 -->
    <el-dialog
      :close-on-click-modal="false"
      title="变更人员所属项目"
      :visible.sync="dialogUpdateProjectShow"
      class="mini-dialog"
      v-dialogDrag
    >
      <el-form ref="formProject" label-width="150px" :rules="rulesProject" :model="formProject">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="关联项目" prop="projectId">
              <el-select
                v-model="formProject.projectId"
                size="small"
                placeholder="请选择项目"
                filterable
                clearable
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.projectName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button size="small" type="primary" @click="submitUpdateProject">确定</el-button>
        <el-button size="small" @click="dialogUpdateProjectShow = false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="违章信息详情"
      :visible.sync="showViolation"
      width="90%"
      class="large-dialog pr-10px"
      v-dialogDrag
    >
      <el-button @click="viewProcess" plain class="flot-right" v-if="'vioExamine' !== pageName"
        >查看流程</el-button
      >
      <BasicInfoCom
        :propsKey="propsKey"
        :operateType="['vioExamine'].includes(pageName) ? 'create' : 'action'"
        ref="BasicInfoCom"
      />
      <MainCom :operateFormat="operateFormat" ref="MainInfoCom" :propsStatus="6" />
      <!-- 延期 -->
      <!-- <DelayReq :visible.sync="delayVis" v-if="delayVis" :delayData="originData" /> -->
    </el-dialog>
    <ApprovalFlowDialog
      :visible.sync="approvalFlowDialog"
      v-if="approvalFlowDialog"
      :id="flowTaskId"
      @cancel="approvalFlowDialog = false"
    >
    </ApprovalFlowDialog>
    <!-- 查看流程start -->
    <ReportFlow
      :visible.sync="showFlowDialog"
      v-if="showFlowDialog"
      :flowid="flowid"
      :groupid="groupid"
    />
    <!-- 查看流程end -->
  </div>
</template>

<script type="text/babel">
import dayjs from 'dayjs'
import utils from '@/components/safety/enumField/utils'
import TrainManageRecordList from '@/modules/educational-training-management-sm/views/trainManage/RecordList.vue'
import ExamManageRecordStudy from '@/modules/educational-training-management-sm/views/examManage/RecordStudy.vue'
import AntiViolationManagementFileInfo from '@/components/safety/WizSafetyPage/violation/FileInfo.vue'
import { sourceList } from '@/components/safety/WizSafetyPage/violation/enums'
import MainCom from '@/components/safety/WizSafetyPage/violation/MainCom.vue'
import BasicInfoCom from '@/components/safety/WizSafetyPage/violation/BasicInfoCom.vue'
import ReportFlow from '@/components/safety/WizSafetyPage/violation/ReportFlow.vue'
// import DelayReq from '@/modules/anti-violation-management/components/DelayReq.vue'

import {
  ContractorPersonnelApi,
  ContractorApi,
  ContractorPersonnelCertificateApi,
  ContractorProjectApi,
  ContractorAccountRelationApi,
  ContractorPersonnelConfigurationApi,
} from '@wiz-api/contractor-management'
import PersonEnterContent from '@/components/safety/WizSafetyPage/PersonEnterContent'
import { unitStatusTypes, workFlowStatusTypes } from '@/components/safety/enumField/enumTypeMethods'
import ApprovalFlowDialog from '@/components/safety/ApprovalFlow/ApprovalFlowDialog'
import { ViolationRecordApi } from '@wiz-api/personnel-safety-management'
import { PlanApi } from '@wiz-api/emergency-management'
import qs from 'qs'

const contractorApi = new ContractorApi()
const contractorProjectApi = new ContractorProjectApi()
const contractorPersonnelApi = new ContractorPersonnelApi()
const contractorAccountRelationApi = new ContractorAccountRelationApi()
const contractorPersonnelCertificateApi = new ContractorPersonnelCertificateApi()
const contractorPersonnelConfigurationApi = new ContractorPersonnelConfigurationApi()
const violationRecordApi = new ViolationRecordApi()
const planApi = new PlanApi()
export default {
  name: 'person-files',
  components: {
    PersonEnterContent,
    ApprovalFlowDialog,
    TrainManageRecordList,
    ExamManageRecordStudy,
    AntiViolationManagementFileInfo,
    MainCom,
    BasicInfoCom,
    ReportFlow,
  },
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      }, // 分页器
      delayVis: false,
      showFlowDialog: false,
      flowid: '',
      groupid: '',
      originData: { violationRecord: {}, violationHandling: {} },
      operateFormat: {},
      propsKey: '',
      pageName: '',
      showViolation: false,
      saveRowData: {},
      projectList: [],
      blackList: [
        { code: true, displayName: '是' },
        { code: false, displayName: '否' },
      ],
      approvalFlowDialog: false,
      flowTaskId: null,
      contractorPersonnelId: null,
      contractorId: null,
      workFlowStatusList: [],
      formData: {
        contractId: '',
        infDocFileName: '',
        infDocFileId: '',
        name: '',
        phoneNumber: '',
        age: null,
        idCard: '',
        sex: null,
        national: '',
        education: null,
        isTemp: true,
        personnelCategory: null,
        team: null,
        dutieJob: null,
        isSpecialOperationCertificatePersonnel: true,
        contractorId: '',
        projectId: '',
        headshotFileId: '',
        idCardFrontFileId: '',
        idCardReverseFileId: 0,
        jobs: null,
        contractorPersonnelConfigurations: [],
        contractorPersonnelCertificates: [],
      },
      formProject: {
        projectId: '',
      },
      rulesProject: {
        projectId: [{ required: true, message: '请选择关联项目', trigger: ['change', 'blur'] }],
      },
      dialogUpdateProjectShow: false,
      isSpecialOperationCertificatePersonnelList: [],
      statusList: [],
      formList: [],
      selectionData: [],
      historyTotalCount: 0,
      historyLoading: false,
      currentComp: 'TABLE',
      dialogBlackShow: false,
      personId: '',
      activeModule: '0',
      selecttionData: [],
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      FormData: {
        evaluationOpinions: '',
      },
      searchData: {
        isBlock: undefined,
        status: null,
        contractorId: null,
        isSpecialOperationCertificatePersonnel: null,
        isArchives: true,
        workflowStatus: null,
      },
      currentTreeSelect: null,
      total: 0,
      treeDialog: false,
      treeDialogTitle: '',
      treeKeyword: '',
      treeLoading: false,
      defaultTreeProps: {
        children: 'children',
        label: 'orgName',
      },
      treeData: [
        {
          orgName: '承包商',
          id: '2ca06d46-e8bd-46e1-aaf9-927d5ba86f33',
          isCompany: true,
          children: [],
        },
      ],
      defaultExpandIds: [],
      keyword: '',
      tableData: [],
      loading: false,
      pid: '',
      moduleList: [
        {
          module: '0',
          moduleName: '基本信息',
        },
        {
          module: '1',
          moduleName: '培训信息',
        },
        {
          module: '2',
          moduleName: '考试信息',
        },
        {
          module: '3',
          moduleName: '违章信息',
        },
      ],
    }
  },
  created() {
    utils.getDataCategory(
      [
        'ContractorManagement.DataCategory.IncomingfactoryStatus',
        'ContractorManagement.DataCategory.IsSpecialOperationCertificatePersonnel',
        'ContractorManagement.DataCategory.WorkflowStatus',
      ],
      ['statusList', 'isSpecialOperationCertificatePersonnelList', 'workFlowStatusList'],
      this
    )
    this.getContractorInfo()
    this.getTreeData()
  },
  computed: {
    statusFilterList() {
      return this.statusList.filter((item) => {
        return item.code !== '0' && item.code !== '3'
      })
    },
    unitStatusTypes() {
      return (val) => {
        return unitStatusTypes(val)
      }
    },
    workFlowStatusTypes() {
      return (val) => {
        return workFlowStatusTypes(val)
      }
    },
    unitStatusMap() {
      return (val) => {
        return (
          this.statusList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    workFlowStatusMap() {
      return (val) => {
        return (
          this.workFlowStatusList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
  },
  methods: {
    async getViolationInfo() {
      const params = {
        maxResultCount: this.page.pageSize,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        sorting: 'CreationTime DESC',
        personnelId: this.saveRowData.accountId,
      }
      if (params._date) {
        params._date = new Date(params._date)
      }
      const [err, res] = await violationRecordApi.violationArchives(params)
      if (err || !res.items.length) {
        sessionStorage.setItem(
          'CURRENT_VIOLATION_PEOPLE',
          JSON.stringify({
            personnelName: this.saveRowData.name,
            unitName: this.saveRowData.contractorName,
            totalScore: null,
            punishCount: 0,
            penaltyScore: 0,
            penaltyAmount: 0,
            trainHour: 0,
            rewardCount: 0,
            rewardScore: 0,
            rewardAmount: 0,
          })
        )
      } else {
        sessionStorage.setItem('CURRENT_VIOLATION_PEOPLE', JSON.stringify(res.items[0]))
      }
    },
    // 流程
    async viewProcess() {
      const [err, res] = await planApi.getFlowTaskInfo({
        flowTaskId: this.originData.violationRecord.flowTaskId,
      })
      if (!err) {
        this.flowid = res.flowId
        this.groupid = res.groupId
        this.showFlowDialog = true
      }
    },
    // 获取详情
    async getDetail(id) {
      const [err, res] = await violationRecordApi.getRecord({ id })
      if (err && !res) return
      this.$refs.BasicInfoCom?.detailShow(res.violationRecord)
      this.$refs.MainInfoCom?.detailShow(res.violationHandling)
      this.originData = res
      // this.reqCount = this.reqCount + 1
    },
    showviolationDialog(params) {
      this.getDetail(params.id)
      this.showViolation = true
      this.propsKey = sourceList[params.operateType].base
      this.pageName = params.operateType
      this.operateFormat = sourceList[params.operateType]
    },
    // 禁用复选框 0禁用 1不禁用
    // 不能给自己账号加入黑名单或者变更项目
    isDisabled(row) {
      if (this.contractorPersonnelId && this.contractorPersonnelId === row.id) {
        return 0
      }
      return 1
    },
    async getContractorInfo() {
      // 拿承包商id和模板id
      const [err, res] = await contractorAccountRelationApi.getContractorAccountRelationByUserDto()
      if (!err) {
        this.contractorId = res.contractorId
        this.contractorPersonnelId = res.contractorPersonnelId
      }
    },
    // 获取项目清单列表
    async getSafetyProjectList() {
      const data = {
        contractorId: this.currentTreeSelect.id,
        maxResultCount: 999, // 每页多少条
        skipCount: 0, // 跳过多少条
      }
      const [error, result] = await contractorProjectApi.relatedProjectPageList(data)
      if (!error) {
        this.projectList = result.items || []
      }
    },
    // 查看流程
    handleFlow(row) {
      this.flowTaskId = row.entryFlowTaskId
      if (typeof this.flowTaskId === 'string' && _.includes(this.flowTaskId, '-')) {
        window.wiz.OpenWorkFlowDesignByFlowId(this.flowTaskId)
      } else {
        this.approvalFlowDialog = true
      }
    },
    // 加入黑名单
    async handleSubmit() {
      if (!this.FormData.evaluationlevel) {
        this.$message({
          showClose: true,
          message: '请选择评价等级',
          type: 'warning',
        })
        return
      }
      const filterData = []
      this.selectionData.forEach((item) => {
        if (!item.isBlock) {
          filterData.push(item.id)
        }
      })
      const data = filterData.map((item) => {
        return {
          ...this.FormData,
          relatedId: item,
          status: 3,
        }
      })
      const [error, res] = await contractorPersonnelApi.statusMany({ body: data })
      if (!error) {
        this.$message({
          showClose: true,
          message: '加入黑名单成功',
          type: 'success',
        })
        this.dialogBlackShow = false
        this.findList()
      }
    },
    // 返回页面
    handleBack() {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = 'TABLE'
      })
    },
    // 多选事件
    selectionChange(values) {
      this.selectionData = values
    },
    // 变更项目
    async updateProject() {
      if (this.selectionData.length === 0) {
        this.$message({
          showClose: true,
          message: '请勾选记录',
          type: 'warning',
        })
        return
      }
      // 是否存在黑名单的人员，黑名单不允许变更项目
      const isPass = _.every(this.selectionData, (item) => {
        return !item.isBlock
      })
      if (!isPass) {
        this.$message({
          showClose: true,
          message: '勾选的数据存在黑名单，无法变更项目，请重新勾选',
          type: 'warning',
        })
        return
      }
      // 初始化表单
      this.formProject = this.$options.data().formProject
      this.dialogUpdateProjectShow = true
    },
    submitUpdateProject() {
      this.$refs.formProject.validate(async (valid) => {
        if (valid) {
          const data = this.selectionData.map((item) => {
            return {
              contractorPersonnelId: item.id,
              projectId: this.formProject.projectId,
            }
          })
          const [err, res] = await contractorPersonnelApi.projectMany({ body: data })
          if (!err) {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            })
            this.dialogUpdateProjectShow = false
            this.findList()
          }
        }
      })
    },
    // 加入黑名单
    handleAddBlack() {
      if (this.selectionData?.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择记录',
          type: 'warning',
        })
        return
      }
      const filterData = []
      this.selectionData.forEach((item) => {
        if (!item.isBlock) {
          filterData.push(item.id)
        }
      })
      if (filterData.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择非黑名单记录',
          type: 'warning',
        })
        return
      }
      // 加入黑名单
      this.dialogBlackShow = true
      this.$nextTick(() => {
        this.$refs.formActive.resetFields()
      })
    },
    // 移除黑名单
    handleRemove() {
      // 当前选择的单位是否为黑名单
      if (this.currentTreeSelect && this.currentTreeSelect.isBlock) {
        this.$message({
          showClose: true,
          message: '请先将该单位移除黑名单后，再进行操作',
          type: 'warning',
        })
        return
      }
      if (this.selectionData.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择记录',
          type: 'warning',
        })
        return
      }
      const filterData = []
      this.selectionData.forEach((item) => {
        if (item.isBlock) {
          filterData.push(item.id)
        }
      })
      if (filterData.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择有效的黑名单记录',
          type: 'warning',
        })
        return
      }
      this.$confirm('确认移除黑名单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await contractorPersonnelApi.removeBlackRecord({ body: filterData })
          if (!err) {
            this.$message({
              showClose: true,
              message: '移除黑名单成功',
              type: 'success',
            })
            this.findList()
          }
        })
        .catch(() => {})
    },
    // 详情
    async handleDetail(row) {
      this.saveRowData = row
      this.getViolationInfo()
      this.formData = this.$options.data().formData
      const [error, result] = await contractorPersonnelApi.get(row.id)
      if (!error) {
        this.formData = {
          ...this.formData,
          ...result,
        }
        // 获取证书是否提供
        const [
          errCard,
          resCard,
        ] = await contractorPersonnelCertificateApi.contractorPersonnelCertificateDto({
          contractorPersonnelId: row.id,
        })
        if (!errCard) {
          // 时间格式化
          resCard.forEach((item, index) => {
            item.certificateDate = dayjs(item.certificateDate).format('YYYY-MM-DD')
          })
          this.$set(this.formData, 'contractorPersonnelCertificates', resCard)
        }
        // 获取资料是否提供
        const [
          err,
          res,
        ] = await contractorPersonnelConfigurationApi.contractorPersonnelConfiguration({
          contractorPersonnelId: row.id,
        })
        if (!err) {
          this.formList = res.map((item, index) => {
            return {
              id: item.id,
              configurationId: item.configurationId,
              label: item.title,
              field: `field${index}`,
              textfield: `textfield${index}`,
              // 获取有无情况以及说明
              isProvided: item.isProvided,
              description: item.description,
              isRequired: item.isRequired,
            }
          })
          this.currentComp = null
          this.$nextTick(() => {
            this.currentComp = 'DETAIL'
          })
        }
      }
    },
    // 搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.findList()
    },
    resetSearch() {
      const contractorId = this.searchData.contractorId
      const searchData = this.$options.data().searchData
      searchData.contractorId = contractorId
      this.searchData = searchData
      this.handleSearch()
    },
    // 页码改变
    tableSizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.findList()
    },
    // 页数改变
    tableCurrentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.findList()
    },
    // TODO:treeData,为前端模拟，后续操作涉及是否能变更项目
    async getTreeData() {
      this.treeLoading = true
      const [err, res] = await contractorApi.contractorNamesDto()
      if (!err) {
        this.treeData[0].children = res
        // 初始化选中第一个承包商
        this.currentTreeSelect = this.treeData[0]?.children[0]
        this.searchData.contractorId = this.treeData[0]?.children[0]?.id
        this.defaultExpandIds = [this.treeData[0]?.children[0]?.id]
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.treeData[0]?.children[0]?.id)
        })
        this.findList()
        this.getSafetyProjectList()
      }
      this.treeLoading = false
      // this.treeData = this.JSONToTree(list.reverse())
    },
    filterTreeNode(value, data) {
      if (!value) {
        return true
      }
      return data.orgName.indexOf(value) !== -1
    },
    // 搜索
    searchTreeData() {
      this.$refs.tree.filter(this.treeKeyword)
    },
    // 节点展开
    nodeExpand(data) {
      this.defaultExpandIds.push(data.id)
    },
    // 节点关闭
    nodeCollapse(data) {
      this.defaultExpandIds = _.difference(this.defaultExpandIds, [data.id])
    },
    // 节点点击
    handleDocNodeClick(data) {
      this.searchData = this.$options.data().searchData
      this.currentTreeSelect = data
      this.searchData.contractorId = data.isCompany ? this.contractorId : data.id
      this.getSafetyProjectList()
      this.searchList()
    },
    searchList() {
      this.pageConfig.SkipCount = 1
      this.findList()
    },
    // 数组转化成树结构
    JSONToTree(data, parent = null, pid = 'parentId') {
      const tree = []
      let temp = []
      // eslint-disable-next-line no-restricted-syntax
      for (const i of data) {
        if (i[pid] === parent) {
          const obj = i
          temp = this.JSONToTree(data, i.id, pid)
          if (temp.length > 0) {
            obj.children = temp
          }
          tree.push(obj)
        }
      }
      return tree
    },
    // 查询人员列表
    async findList() {
      this.loading = true
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
      }
      if (window.__POWERED_BY_QIANKUN__) {
        // 低代码
        const instance = axios.create()
        instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
        const token = localStorage.getItem('authorization')
        instance.defaults.headers.common.Authorization = `Bearer ${token}`
        const res = await instance.get(
          `/api/contractor-management/contractor-personnels/paged-list-query?${qs.stringify({
            ...data,
            ...this.searchData,
          })}`
        )
        if (res.status === 200 && res.data) {
          this.tableData = res.data.items || []
          this.total = res.data.totalCount || 0
        }
        this.loading = false
        return
      }
      const [err, res] = await contractorPersonnelApi.pagedListQuery({
        ...data,
        ...this.searchData,
      })
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.loading = false
      }
    },
    // 删除
    async handleDel(data) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {})
        .catch(() => {
          console.log('delete')
        })
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
.tree {
  height: calc(100% - 74px);
  ::v-deep .el-tree-node__content {
    height: 35px;
    .node-item {
      width: calc(100% - 24px);
      .custom-tree-node {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}
.el-button + .el-button {
  margin-left: 0px !important;
  margin-right: 10px;
}
.button-normal.el-button.el-tooltip {
  width: unset !important;
  height: unset !important;
  padding: 6px 12px !important;
}
::v-deep .el-select__tags .el-tag {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rightCol {
  ::v-deep .el-card__body {
    height: 100%;
  }
}

.detail-height {
  height: calc(100% - 110px);
}
</style>
